var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "1000px" },
      scopedSlots: _vm._u(
        [
          {
            key: "activator",
            fn: function ({ on, attrs }) {
              return [_vm._t("clickable", null, { on: on, attrs: attrs })]
            },
          },
        ],
        null,
        true
      ),
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "v-card",
        { attrs: { "data-cy": "editEvaluationModal" } },
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [
              _vm._v('Edit "' + _vm._s(_vm.activeEvaluation.filename) + '"'),
            ]),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-container",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "7" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              "data-cy": "filename",
                              label: "File name",
                            },
                            model: {
                              value: _vm.activeEvaluation.filename,
                              callback: function ($$v) {
                                _vm.$set(_vm.activeEvaluation, "filename", $$v)
                              },
                              expression: "activeEvaluation.filename",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "5" } },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.visibilityOptions,
                              label: "Visibility",
                            },
                            model: {
                              value: _vm.activeEvaluation.public,
                              callback: function ($$v) {
                                _vm.$set(_vm.activeEvaluation, "public", $$v)
                              },
                              expression: "activeEvaluation.public",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "7", md: "9" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: "Groups",
                              multiple: "",
                              "deletable-chips": "",
                              items: _vm.myGroups,
                              "search-input": _vm.groupSearch,
                              "return-object": "",
                            },
                            on: {
                              "update:searchInput": function ($event) {
                                _vm.groupSearch = $event
                              },
                              "update:search-input": function ($event) {
                                _vm.groupSearch = $event
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "no-data",
                                fn: function () {
                                  return [
                                    _c(
                                      "v-list-item",
                                      [
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v(' No results matching "'),
                                              _c("strong", [
                                                _vm._v(_vm._s(_vm.groupSearch)),
                                              ]),
                                              _vm._v('". Press '),
                                              _c("kbd", [
                                                _vm._v("Create New Group"),
                                              ]),
                                              _vm._v(" to create one. "),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.groups,
                              callback: function ($$v) {
                                _vm.groups = $$v
                              },
                              expression: "groups",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "5", md: "3" } },
                        [
                          _c("GroupModal", {
                            attrs: { id: "groupModal", create: true },
                            scopedSlots: _vm._u([
                              {
                                key: "clickable",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "mt-3",
                                            attrs: {
                                              block: "",
                                              color: "primary",
                                            },
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [_vm._v(" Create New Group ")]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: {
                    text: "",
                    color: "primary",
                    "data-cy": "closeAndDiscardChanges",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    text: "",
                    color: "primary",
                    "data-cy": "closeAndSaveChanges",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.update()
                    },
                  },
                },
                [_vm._v("Save")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }